import Vue from 'vue'

//moment has bug when import only 'moment' must import 'moment/moment' for use locale
import moment from 'moment/moment';
import { i18n } from '@/setup/i18n-setup';
import { round } from '@/utils'
import {ICaseStatus, IContractSummarizeStatus, IStageAging} from "@/constants/interface";
// import {ICaseStatus} from "@/constants/interface";

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  const arr = value.split(' ')
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('truncate', function (value, limit) {
  return value.substring(0, limit)
})

Vue.filter('tailing', function (value, tail) {
  return value + tail
})

Vue.filter('time', function (value, is24HrFormat = false) {
  if (value) {
    const date = new Date(Date.parse(value))
    let hours = date.getHours()
    const min = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
    if (!is24HrFormat) {
      const time = hours > 12 ? 'AM' : 'PM'
      hours = hours % 12 || 12
      return `${hours}:${min} ${time}`
    }
    return `${hours}:${min}`
  }
})

Vue.filter('date', function (value, fullDate = false) {
  value = String(value)
  const date = value.slice(8, 10).trim()
  const month = value.slice(4, 7).trim()
  const year = value.slice(11, 15)

  if (!fullDate) return `${date} ${month}`
  else return `${date} ${month} ${year}`
})

Vue.filter('month', function (val, showYear = true) {
  val = String(val)

  const regx = /\w+\s(\w+)\s\d+\s(\d+)./
  if (!showYear) {
    return regx.exec(val)[1]
  } else {
    return `${regx.exec(val)[1]} ${regx.exec(val)[2]}`
  }

})

Vue.filter('csv', function (value) {
  return value.join(', ')
})

Vue.filter('filter_tags', function (value) {
  return value.replace(/<\/?[^>]+(>|$)/g, '')
})

Vue.filter('k_formatter', function (num) {
  return num > 999 ? `${(num / 1000).toFixed(1)}k` : num
})

Vue.filter('toDDMMMYYYFormat', function(value) {
  if (!value) {
    return '';
  }

  let date = new Date(parseInt(value));
  return moment(date).locale(i18n.locale).format('D MMM Y');
});

Vue.filter('toDDMMMYYYHMMFormat', function(value) {
  if (!value) {
    return '-';
  }
  if(isNaN(parseInt(value))){
    return '-';
  }

  let date = new Date(parseInt(value));
  return moment(date).locale(i18n.locale).format('D MMM Y H:mm');
});

Vue.filter('toThaiDDMMYYYYFormat', function(value) {
  if (!value) {
    return '-';
  }
  if(isNaN(parseInt(value))){
    return '-';
  }
  moment.locale('th')
  return moment(value).add(543, 'year').format('DD/MM/YYYY')
});

Vue.filter('moneyFormat', function(value) {
  if (!value) {
    return '0';
  }
  if(isNaN(parseInt(value))){
    return '0';
  }
  if (value < 0) {
    return '0';
  }
  value = round(value, 2)
  var parts = value.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
});

Vue.filter('numberFormat', function(value) {
  if (!value) {
    return '0.00';
  }
  if(isNaN(parseInt(value))){
    return '0.00';
  }
  if (value < 0) {
    return '0.00';
  }
  value = round(value, 2)
  const parts = value.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if(!parts[1]) parts[1] = "00"
  else parts[1] = (parts[1].length === 1 ? `${parts[1]}0` : parts[1])
  return parts.join(".");
});

Vue.filter('interestType', function(value) {

  return i18n.t('getters.interestTypesOptions')[value]
});

Vue.filter('loanType', function(value) {

  return i18n.t('getters.loanTypesOptions')[value]
});

Vue.filter('feeType', function(value) {

  return i18n.t('getters.feeTypesOptions')[value]
});

Vue.filter('contractStatus', function(value) {

  return i18n.t('getters.contractStatusesOptions')[value]
});

Vue.filter('educationStatus', function(value) {
  return i18n.t('getters.educationStatusesOptions')[value]
});

Vue.filter('loanDetailType', function(value) {

  return i18n.t('getters.loanDetailTypesOptions')[value]
});

Vue.filter('paymentRoundType', function(value) {

  return i18n.t('getters.paymentRoundTypesOptions')[value]
});

Vue.filter('convPerYear', function(value) {

  return value+"% "+i18n.t('general.perYears')
});

Vue.filter('idCardFormat', function(value) {
  if (!value) {
    return '';
  }
  if (value.length !== 13) {
    return value;
  }
  const conv = value.split("").map((v, i) => {
    const space = [1, 6, 11,14]
    if( space.includes(i) ){
      return ` ${v}`
    }else{
      return v
    }
  })
  return conv.join("")
});

Vue.filter('toThaiBaht', function(value) {
  if (!value) {
    return '';
  }

  const convertThaiBaht = (number, length) => {
    const txtNumber = ['ศูนย์', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า', 'สิบ'];
    const txtDigit = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน', 'ล้าน'];
    let baht = '';

    for (let i = 0; i < length; i += 1) {
      const tmp = number[0].substring(i, i + 1) - 0;

      if (tmp !== 0) {
        if (i === length - 1 && tmp === 1) {
          baht += 'เอ็ด';
        } else if (i === length - 2 && tmp === 2) {
          baht += 'ยี่';
        } else if (i === length - 2 && tmp === 1) {
          baht += '';
        } else {
          baht += txtNumber[tmp];
        }
        baht += txtDigit[length - i - 1];
      }
    }

    return baht;
  };

  let number = String(value);
  // ตัดสิ่งที่ไม่ต้องการทิ้งลงโถส้วม
  for (let i = 0; i < number.length; i += 1) {
    number = number.replace(',', ''); // ไม่ต้องการเครื่องหมายคอมมาร์
    number = number.replace(' ', ''); // ไม่ต้องการช่องว่าง
    number = number.replace('บาท', ''); // ไม่ต้องการตัวหนังสือ บาท
    number = number.replace('฿', ''); // ไม่ต้องการสัญลักษณ์สกุลเงินบาท
  }

  let baht = '';
  // ตรวจสอบดูซะหน่อยว่าใช่ตัวเลขที่ถูกต้องหรือเปล่า ด้วย isNaN == true ถ้าเป็นข้อความ == false ถ้าเป็นตัวเลข
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(number)) {
    return 'ข้อมูลนำเข้าไม่ถูกต้อง';
  }
  // ตรวสอบอีกสักครั้งว่าตัวเลขมากเกินความต้องการหรือเปล่า
  if (number - 0 > 9999999.9999) {
    return 'ข้อมูลนำเข้าเกินขอบเขตที่ตั้งไว้';
  }
  // พรากทศนิยม กับจำนวนเต็มออกจากกัน (บาปหรือเปล่าหนอเรา พรากคู่เขา)
  number = number.split('.');

  // ขั้นตอนต่อไปนี้เป็นการประมวลผลดูกันเอาเองครับ แบบว่าขี้เกียจจะจิ้มดีดแล้ว อิอิอิ
  if (number.length > 1 && number[1].length > 0) {
    number[1] = number[1].substring(0, 2);
  }

  baht = convertThaiBaht(number, number[0].length);
  baht += 'บาท';

  if (number.length === 1 || number[1] === '0' || number[1] === '00') {
    baht += 'ถ้วน';
  } else {
    baht = convertThaiBaht(number, number[1].length);
    baht += 'สตางค์';
  }

  if (baht === 'บาทถ้วน') {
    baht = 'ศูนย์บาทถ้วน';
  }

  return baht
});

Vue.filter('convYYYYMMDDToDDMMYYYY', function(value) {
  if (!value) {
    return '-';
  }
  if (value.length !== 10) {
    return '';
  }
  try {
    return moment(value).format("DD-MM-YYYY")
  } catch (error) {
    return ""
  }
});

Vue.filter('convDDMMYYYYToYYYYMMDD', function(value) {
  if (!value) {
    return '';
  }
  if (value.length !== 10) {
    return '';
  }
  try {
    return moment(value, "DD-MM-YYYY").format("YYYY-MM-DD")
  } catch (error) {
    return ""
  }
});

Vue.filter('toThaiDDMMMYYYYFormat', function(value) {
  if (!value) {
    return '-';
  }
  if(isNaN(parseInt(value))){
    return '-';
  }
  moment.locale('th')
  return moment(value).add(543, 'year').format('DD MMM YYYY')
});

Vue.filter('hierarchy', function(value) {
  const obj = [
    {count: 0, name: "In Due"},
    {count: 45, name: "1-45"},
    {count: 120, name: "46-120"},
    {count: 9999, name: ">=121"},
  ]
  const hierarchy = obj.find(res => value.agingNumber <= res.count ).name
  return hierarchy ? hierarchy : "In Due"
});

Vue.filter('convMomentFormateDDMMYYYY', function(value) {
  try {
    if(moment(value).isValid()){
      return `${moment(value).format("DD-MM-YYYY")}`
    }else{
      return ""
    }
  } catch (error) {
    return ""
  }
});

Vue.filter('caseStatusColor', function(caseStatus) {
  const statusMap = {
    [ICaseStatus.draft]: 'primary',
    [ICaseStatus.sendInformationContractToLawyer]: 'primary',
    [ICaseStatus.lawyerAccepted]: 'warning',
    [ICaseStatus.lawyerSendInquiryLetter]: 'warning',
    [ICaseStatus.negotiateWithLawyerForPayment]: 'warning',
    [ICaseStatus.fileLawsuit]: 'warning',
    [ICaseStatus.courtJudgment]: 'success',
    [ICaseStatus.makeDebtRestructuringContract]: 'success',
    [ICaseStatus.sendEnforcementOrder]: 'success',
    [ICaseStatus.submitForLegalExecution]: 'danger',
    [ICaseStatus.issueWarrantForEnforcementOfficer]: 'danger',
    [ICaseStatus.submitEnforcementCaseDocument]: 'danger',
    [ICaseStatus.announcePublicAuction]: 'danger',
    [ICaseStatus.holdCase]: 'warning',
    [ICaseStatus.cancelCase]: 'dark',
    [ICaseStatus.closeCase]: 'dark',
  };
  const defaultStatus = 'primary';
  return statusMap[caseStatus] || defaultStatus;
});

Vue.filter('caseStatusIcon', function(caseStatus) {
  const statusMap = {
    [ICaseStatus.draft]: 'FileTextIcon',
    [ICaseStatus.sendInformationContractToLawyer]: 'FileTextIcon',
    [ICaseStatus.lawyerAccepted]: 'FileTextIcon',
    [ICaseStatus.lawyerSendInquiryLetter]: 'FileTextIcon',
    [ICaseStatus.negotiateWithLawyerForPayment]: 'FileTextIcon',
    [ICaseStatus.fileLawsuit]: 'FileTextIcon',
    [ICaseStatus.courtJudgment]: 'FileTextIcon',
    [ICaseStatus.makeDebtRestructuringContract]: 'FileTextIcon',
    [ICaseStatus.sendEnforcementOrder]: 'FileTextIcon',
    [ICaseStatus.submitForLegalExecution]: 'FileTextIcon',
    [ICaseStatus.issueWarrantForEnforcementOfficer]: 'FileTextIcon',
    [ICaseStatus.submitEnforcementCaseDocument]: 'FileTextIcon',
    [ICaseStatus.announcePublicAuction]: 'FileTextIcon',
    [ICaseStatus.holdCase]: 'FileTextIcon',
    [ICaseStatus.cancelCase]: 'FileTextIcon',
    [ICaseStatus.closeCase]: 'FileTextIcon',
  };
  const defaultStatus = 'FileTextIcon';
  return statusMap[caseStatus] || defaultStatus;
});

Vue.filter('contractSummarizeStatus', function(payload) {
  const { contractSummarizeStatus, agingNumber } = payload;
  let contractSummarizeStatusName = contractSummarizeStatus ? i18n.t('getters.contractSummarizeStatusOptions')[contractSummarizeStatus] : i18n.t('general.null');
  contractSummarizeStatusName = contractSummarizeStatus === IContractSummarizeStatus.aging ? `${contractSummarizeStatusName} ${agingNumber} วัน` : contractSummarizeStatusName;
  return contractSummarizeStatusName;
});

Vue.filter('contractSummarizeStatusColor', function(contractSummarizeStatus) {
  const statusMap = {
    [IContractSummarizeStatus.draft]: 'primary',
    [IContractSummarizeStatus.normal]: 'success',
    [IContractSummarizeStatus.aging]: 'warning',
    [IContractSummarizeStatus.prosecution]: 'danger',
    [IContractSummarizeStatus.nplReturn]: 'dark',
    [IContractSummarizeStatus.close]: 'dark',
  };
  const defaultStatus = 'primary';
  return statusMap[contractSummarizeStatus] || defaultStatus;
});

Vue.filter('stageAging', function(stageAging) {
  const stageAgingMap = {
    [IStageAging.normal] : 'ปกติ',
    [IStageAging.stage1] : 'Aging 1 - 30 วัน',
    [IStageAging.stage2] : 'Aging 31 - 60 วัน',
    [IStageAging.stage3] : 'Aging > 60 วัน',
  };
  return stageAgingMap[stageAging] || 'ปกติ';
});
